/* eslint-disable camelcase */
/**
 * @fileoverview GET handler for the "/admin/impersonation_capabilities" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { adminImpersonationCapabilities } from "./constants";
import type { AdminImpersonationCapabilitiesResult } from "./types";

export const getAdminImpersonationCapabilities = reactQueryFetcherAdapter(
  adminImpersonationCapabilities,
  (signal: AbortSignal, impersonation_company_id: string): Promise<AdminImpersonationCapabilitiesResult> => {
    return fetch("/admin/impersonation_capabilities", "GET", { impersonation_company_id }, { signal });
  }
);
